import { Link } from "react-router-dom";
import type { Manga } from "@/mocks/manga";

export default function MangaCard({ manga }: { manga: Manga }) {
  return (
    <article className="group">
      <Link
        to={`/detail/${manga.id}`}
        className="relative block overflow-hidden rounded-xl border border-background-200/70 bg-background-50"
      >
        <div className="relative aspect-[3/4] w-full overflow-hidden">
          <img
            src={manga.cover}
            alt={`${manga.title} 封面，${manga.categoryName}恋爱漫画在线看`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-80"></div>
          <span
            className={`absolute left-2 top-2 rounded-full px-2 py-0.5 text-[11px] font-medium text-background-50 ${
              manga.status === "已完结" ? "bg-accent-500" : "bg-primary-500"
            }`}
          >
            {manga.status}
          </span>
          <span className="absolute right-2 top-2 flex items-center gap-1 rounded-full bg-foreground-950/60 px-2 py-0.5 text-[11px] text-background-50 backdrop-blur-sm">
            <i className="ri-fire-fill text-accent-400"></i>
            {manga.rating}
          </span>
          <div className="absolute inset-x-0 bottom-0 flex translate-y-2 items-center justify-center gap-2 bg-primary-500/0 px-3 pb-3 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
            <span className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50 px-4 py-1.5 text-xs font-medium text-primary-600">
              <i className="ri-play-circle-line"></i>
              开始阅读
            </span>
          </div>
        </div>
        <div className="p-3">
          <h3 className="truncate text-[15px] font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
            {manga.title}
          </h3>
          <div className="mt-1.5 flex items-center justify-between text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-archive-2-line"></i>
              {manga.chapterCount}话
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {manga.viewers}
            </span>
          </div>
          <div className="mt-2 flex flex-wrap gap-1.5">
            {manga.tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </Link>
    </article>
  );
}